import { render } from "./AddItemsFromBIMPLUS.vue?vue&type=template&id=26d9af98"
import script from "./AddItemsFromBIMPLUS.vue?vue&type=script&lang=js"
export * from "./AddItemsFromBIMPLUS.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__